// import React from "react";
import { useState } from "react";
import InnerHero from "../components/InnerHero";
import productsData from "../data/products";
import ProductModal from "../components/ProductCard";
import UsageSafety from "../components/UsageSafety";
import CTASection from "../components/CTASection";

function Insecticides() {
    const [selectedProduct, setSelectedProduct] = useState(null);

    // 🔹 SIRF INSECTICIDE PRODUCTS
    const insecticideProducts = productsData.filter(
        product => product.category === "Insecticide"
    );
    return (
        <>
            <InnerHero
                title="Insecticides"
                subtitle="Effective crop protection solutions to control harmful insects and safeguard crop yield under diverse Indian farming conditions."
                breadcrumb="Home / Products"
                bgImage="/images/img/insec.jpg"
            />

            <section className="category-intro-section">
                <div className="container">
                    <div className="row align-items-center">

                        {/* LEFT CONTENT */}
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="category-intro-content">
                                <h6 className="section-subtitle">CATEGORY OVERVIEW</h6>
                                <h2>
                                    Reliable <span>Insect Control</span> for Healthier Crops
                                </h2>

                                <p>
                                    Insects are one of the major causes of crop damage, directly
                                    affecting plant health, yield quality, and farmer income.
                                    Effective insect control is essential to protect crops at
                                    every stage of growth.
                                </p>

                                <p>
                                    Goodweel Crop Care offers a wide range of advanced insecticide
                                    solutions designed to control sucking and chewing pests while
                                    maintaining crop safety and environmental balance. Our
                                    formulations are developed through scientific research and
                                    tested under real Indian field conditions.
                                </p>

                                <p>
                                    With a focus on performance, safety, and ease of application,
                                    our insecticides help farmers achieve better crop protection,
                                    reduced losses, and consistent productivity.
                                </p>
                            </div>
                        </div>

                        {/* RIGHT IMAGE */}
                        <div className="col-lg-6">
                            <div className="category-intro-image">
                                <img
                                    src="/images/img/15.jpg"
                                    alt="Insecticides Crop Protection"
                                    className="img-fluid"
                                />
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {/* SECTION HEADING */}
            <div className="container text-center my-5">
                <h2 className="section-title">
                    Our <span>Insecticide Products</span>
                </h2>
                <p className="section-desc">
                    Discover our range of scientifically developed insecticides
                    designed to control harmful pests and protect crop yield
                    under Indian farming conditions.
                </p>
            </div>

            {/* PRODUCTS GRID (CSS SAME AS PRODUCT PAGE) */}
            <div className="container">
                <div className="row">
                    {insecticideProducts.map(product => (
                        <div
                            className="col-lg-3 col-md-4 col-sm-6 mb-4 Product-col"
                            key={product.id}
                        >
                            <div
                                className="product-card"
                                onClick={() => setSelectedProduct(product)}
                            >
                                <img
                                    src={product.image}
                                    alt={product.name}
                                />
                                <div className="product-overlay">
                                    <h6>{product.name}</h6>
                                </div>
                            </div>
                        </div>
                    ))}

                    {/* SAFETY CHECK */}
                    {insecticideProducts.length === 0 && (
                        <p className="text-center mt-4">
                            No insecticide products available at the moment.
                        </p>
                    )}
                </div>
            </div>

            {/* PRODUCT DETAILS MODAL (UNCHANGED) */}
            {selectedProduct && (
                <ProductModal
                    product={selectedProduct}
                    close={() => setSelectedProduct(null)}
                />
            )}
            <UsageSafety />
            <CTASection />

        </>
    );
};

export default Insecticides;
